import Person from '@models/person';
import SearchIcon from '@mui/icons-material/Search';
import { useGetPagedPersonQuery } from '@services/personApi';

import { Autocomplete, Box, InputAdornment, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { useThrottle } from 'react-use';

const ON_CHANGE_DELAY = 500; // 0.5 second

interface SearchPersonProps {
  label: string;
  person: Person | null;
  onChangePerson: (newPerson: Person) => void;
}

export default function SearchPerson(props: SearchPersonProps) {
  const { label, person, onChangePerson } = props;

  const [inputValue, setInputValue] = useState('');
  const throttledSearchTerm = useThrottle(inputValue, ON_CHANGE_DELAY);

  const { data: personList } = useGetPagedPersonQuery({
    query: throttledSearchTerm,
    page: 0,
    size: 10,
  });

  return (
    <Box sx={{ mb: 2 }}>
      {label && <Typography sx={{ fontWeight: 'bold', fontSize: 14 }}>{label}</Typography>}
      <Autocomplete
        autoHighlight
        value={person || ''}
        freeSolo
        fullWidth
        filterOptions={(option) => option}
        isOptionEqualToValue={(option, value) => option.email === value.email}
        size="small"
        onChange={(event, newValue) => {
          onChangePerson(newValue as Person);
        }}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
        }}
        options={personList ? personList.content.map((option: Person) => option) : []}
        getOptionLabel={(option) => {
          if (typeof option === 'string') {
            return option;
          }
          return option && option.name && option.email ? `${option.name} (${option.email})` : '';
        }}
        renderOption={(params, option) => (
          // eslint-disable-next-line react/jsx-props-no-spreading
          <Box component="li" sx={{ fontSize: '13px', '& > img': { mr: 2, flexShrink: 0 } }} {...params}>
            {option.name} ({option.email})
          </Box>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            name="person-search"
            sx={{
              '& input': {
                marginY: 0.5,
              },
            }}
            size="small"
            style={{ width: 'inherit', height: '32px', fontSize: '13px' }}
            ref={params.InputProps.ref}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              ),
              style: {
                paddingRight: '10px',
                paddingTop: '0px',
                paddingBottom: '0px',
                paddingLeft: '10px',
                fontSize: '13px',
              },
            }}
            autoFocus
            placeholder="Pesquisar por nome ou e-mail do colaborador"
          />
        )}
      />
    </Box>
  );
}
